function inlineFilterItems(self) {
  return [
    {
      id: 'all',
      label: self.$t('trackingTemp.status.all'),
    },
    {
      id: 'active',
      label: self.$t('trackingTemp.status.active'),
    },
    {
      id: 'expired',
      label: self.$t('trackingTemp.status.nonActive'),
    },
  ]
}

export default inlineFilterItems
